import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';
import type { CMSApiBase, CMSImageBase } from '@/api/cms/base';
import { fetcherCMS } from '@/modules/api';
import { createCMSQuery, getCMSImageFieldsUrl } from '@/modules/cms';
import type { GameCovers } from '@/store/commonStore/types';

export interface ICMSGameCover extends CMSApiBase {
  gameId: string;
  cover: CMSImageBase;
  gradientColor: string;
}

const GAME_COVERS_LIMIT = 3000;

export const useCMSGameCovers = () => {
  const query = useMemo(
    () =>
      createCMSQuery({
        populate: {
          ...getCMSImageFieldsUrl('cover'),
        },
        pagination: {
          pageSize: GAME_COVERS_LIMIT,
        },
      }),
    []
  );

  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<ICMSGameCover[]>(`/game-covers?${query}`, fetcherCMS);

  const covers = useMemo(
    () =>
      data.reduce((acc, { gameId, cover, gradientColor }) => {
        acc[gameId] = { cover, gradientColor };
        return acc;
      }, {} as GameCovers),
    [data]
  );

  return {
    covers,
    error,
    isLoading,
  };
};
